module.exports = __webpack_public_path__ + "static/media/icon_gerenhaomashensu.b0a659e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/icon_gerenhaomashensu.svg
// module id = 224
// module chunks = 0